import React, { useRef, useState, useEffect } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './personInfo.css';
import loading from '../../img/loading.gif';
import print from '../../img/print.png'
import edit from '../../img/edit.png'
import trash from '../../img/trash.png'
import maps from '../../img/maps.png'
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { GoogleMap, LoadScript, Polyline, Polygon } from '@react-google-maps/api';
import { Buffer } from 'buffer'
import {
    createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed,
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed,
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed,
    showError,
    createBS
} from '../ViewCreator';

const containerStyle = {
    width: '100%',
    height: '100%',
};

const initialCenter = {
    lat: 50.4501, // Київ
    lng: 30.5234,
};


const cookies = new Cookies();
function MapsInfo() {
    var dataFromBackend = []
    const [elements, setElements] = useState([]);

    const mapRef = useRef(null);
    const [mapCenter, setMapCenter] = useState(initialCenter);
    var pm = undefined;


    const onLoad = (map) => {
        mapRef.current = map;
    };

    useEffect(() => {



        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        const tt = queryParams.get("type");
        if (tt === '0') {
            sendBS(id);
        } else if (tt === '1') {
            sendPerson(id);
        }
    }, []);

    const sendBS = (id) => {
        var path = ip + '/api/bs/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    Swal.fire({
                        title: result.msg,
                        icon: "error",
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'ОК',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                    })

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    var pe = createBS(pers)
                    zz.push(pe)

                    setViews(zz)

                    const newCenter = {
                        lat: pers.lat,
                        lng: pers.lon
                    };

                    if (mapRef.current) {
                        mapRef.current.panTo(newCenter);
                    }
                    setMapCenter(newCenter);



                    

                    var pp = pers.band
                    var rad = 1500
                    if (pp == '2600') {
                        rad = 1500
                    } else if (pp == '2100') {
                        rad = 2000
                    } else if (pp == '1800') {
                        rad = 3000
                    } else if (pp == '900') {
                        rad = 5000
                    }

                    var bs = {
                        start: { lat: pers.lat, lng: pers.lon },
                        end: getDestinationPoint({ lat: pers.lat, lng: pers.lon }, rad, parseInt(pers.az)),
                        radius: rad,
                        startAngle: parseInt(pers.az) - 60,
                        endAngle: parseInt(pers.az) + 60,
                        color: (pers.mcc == 255 && pers.mnc == 1) ? '#FF0000' : (pers.mcc == 255 && pers.mnc == 3) ? '#0000FF' : (pers.mcc == 255 && pers.mnc == 6) ? '#FFFF00' : '#00FF00'
                    }

                    dataFromBackend.push(bs)

                    setElements(dataFromBackend);


                }
            })
    }

    const sendPerson = (id) => {
        var path = ip + '/api/person/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then(async (buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    

                    var pers = result.data


                    pm = pers

                    paintBS()
                    
                    



                    

                }
            })
    }

    const paintBS = () => {
        var zz = []
        if (pm.bs.length > 0) {
            var adr = document.createElement('div');
            adr.innerHTML = "<br><hr>Базові станції:";
            zz.push(adr)
            for (let index = 0; index < pm.bs.length; index++) {
                var a = createBSCollapsed(pm.bs[index].bs, index, pm.bs[index].type, pm.bs[index].text, "Д", "Р");
                //zz.push(a)
                if (pm.bs[index].bs.lat === 0) {
                    getCoordinatesByAddress(index,0)
                } else {

                   var bse = addBS(pm.bs[index].bs, zz, a, index)

                    dataFromBackend.push(bse)
                }
            }
        } 

        if (pm.addresses.length > 0) {
            var adr = document.createElement('div');
            adr.innerHTML = "<br><hr>Адреси:";
            zz.push(adr)
            for (let index = 0; index < pm.addresses.length; index++) {
                var aaaa = pm.addresses[index].address
                var a = createAddressCollapsed(aaaa, index, pm.addresses[index].type, pm.addresses[index].text, "Р", "П");

                if (pm.addresses[index].address.lat === undefined) {
                    getCoordinatesByAddress(index,1)
                } else {

                   var bse = addAddress(pm.addresses[index].address, zz, a, index)

                    dataFromBackend.push(bse)
                }


                /*
                zz.push(a)
                var i = pers.addresses[index].address.id
                const dblcl = i => () => {
                    sendAddressFullScreen(i)
                }
                a.ondblclick = dblcl(pers.addresses[index].address.id)
                zz.push(a)*/
            }


        setViews(zz)
        setElements(dataFromBackend);
    }
}


const paintSimpleBS = () => {
    var zz = []
    if (pm.bs.length > 0) {
        var adr = document.createElement('div');
        adr.innerHTML = "<br><hr>Базові станції:";
        zz.push(adr)
        for (let index = 0; index < pm.bs.length; index++) {
            var a = createBSCollapsed(pm.bs[index].bs, index, pm.bs[index].type, pm.bs[index].text, "Д", "Р");
            //zz.push(a)
            if (pm.bs[index].bs.lat === 0) {
                
            } else {

               var bse = addBS(pm.bs[index].bs, zz, a, index)

                dataFromBackend.push(bse)
            }
        }
    } 

    if (pm.addresses.length > 0) {
        var adr = document.createElement('div');
        adr.innerHTML = "<br><hr>Адреси:";
        zz.push(adr)
        for (let index = 0; index < pm.addresses.length; index++) {
            var aaaa = pm.addresses[index].address
            var a = createAddressCollapsed(aaaa, index, pm.addresses[index].type, pm.addresses[index].text, "Р", "П");

            if (pm.addresses[index].address.lat === undefined) {
                
            } else {

               var bse = addAddress(pm.addresses[index].address, zz, a, index)

                dataFromBackend.push(bse)
            }


            /*
            zz.push(a)
            var i = pers.addresses[index].address.id
            const dblcl = i => () => {
                sendAddressFullScreen(i)
            }
            a.ondblclick = dblcl(pers.addresses[index].address.id)
            zz.push(a)*/
        }


    setViews(zz)
    setElements(dataFromBackend);
}
}


    const addBS = (bs, zz, a, index ) => {
        const dblcl = i => () => {
            const newCenter = {
                lat: bs.lat,
                lng: bs.lon
            };

            if (mapRef.current) {
                mapRef.current.panTo(newCenter);
            }
            setMapCenter(newCenter);
        }
        a.onclick = dblcl(bs.id)
        zz.push(a)

        var bbb = bs

        if (index === 0) {
            const newCenter = {
                lat: bbb.lat,
                lng: bbb.lon
            };

            if (mapRef.current) {
                mapRef.current.panTo(newCenter);
            }
            setMapCenter(newCenter);
        }


        var pp = bbb.band
        var rad = 1500
        if (pp == '2600') {
            rad = 1500
        } else if (pp == '2100') {
            rad = 2000
        } else if (pp == '1800') {
            rad = 3000
        } else if (pp == '900') {
            rad = 5000
        }

        var bse = {
            start: { lat: bbb.lat, lng: bbb.lon },
            end: getDestinationPoint({ lat: bbb.lat, lng: bbb.lon }, rad, parseInt(bbb.az)),
            radius: rad,
            startAngle: parseInt(bbb.az) - 60,
            endAngle: parseInt(bbb.az) + 60,
            color: (bbb.mcc == 255 && bbb.mnc == 1) ? '#FF0000' : (bbb.mcc == 255 && bbb.mnc == 3) ? '#0000FF' : (bbb.mcc == 255 && bbb.mnc == 6) ? '#FFFF00' : '#00FF00'
        }

        return bse

       
    }

    const addAddress = (bs, zz, a, index ) => {
        const dblcl = i => () => {
            const newCenter = {
                lat: bs.lat,
                lng: bs.lon
            };

            if (mapRef.current) {
                mapRef.current.panTo(newCenter);
            }
            setMapCenter(newCenter);
        }
        a.onclick = dblcl(bs.id)
        zz.push(a)

        var bbb = bs

        if (index === 0) {
            const newCenter = {
                lat: bbb.lat,
                lng: bbb.lon
            };

            if (mapRef.current) {
                mapRef.current.panTo(newCenter);
            }
            setMapCenter(newCenter);
        }

        var bse = {
            start: { lat: bbb.lat, lng: bbb.lon },
            end: { lat: bbb.lat, lng: bbb.lon },
            radius: 50,
            startAngle: 0,
            endAngle: 360,
            color: '#FF00FF'
        }

        return bse

       
    }

    async function getCoordinatesByAddress(index, type) {
        const apiKey = "AIzaSyAe9bZGewj0M5fHhyhcUoR6iY0F41uIArk";
        var data = undefined;
        if (type === 0){
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(pm.bs[index].bs.address)}&key=${apiKey}`
            );
            
            data = await response.json();
        } else {
            var adr = "";
            var aa = pm.addresses[index].address

            adr =  aa.region + " " + aa.ato + " " + aa.np + " " + aa.street + " " + aa.buiding
            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(adr)}&key=${apiKey}`
            );
            
            data = await response.json();
        }

        if (data.status === "OK") {
            if (type === 0) {
                pm.bs[index].bs.lat = data.results[0].geometry.location.lat
                pm.bs[index].bs.lon = data.results[0].geometry.location.lng
            } else {
                pm.addresses[index].address.lat = data.results[0].geometry.location.lat
                pm.addresses[index].address.lon = data.results[0].geometry.location.lng
            }
            paintSimpleBS();
        } else {
            throw new Error("Адресу не знайдено");
        }
    }

    function getDestinationPoint(start, distanceMeters, bearingDegrees) {
        const R = 6371000; // радіус Землі в метрах
        const bearingRad = bearingDegrees * Math.PI / 180;

        const lat1 = start.lat * Math.PI / 180;
        const lon1 = start.lng * Math.PI / 180;

        const lat2 = Math.asin(
            Math.sin(lat1) * Math.cos(distanceMeters / R) +
            Math.cos(lat1) * Math.sin(distanceMeters / R) * Math.cos(bearingRad)
        );

        const lon2 = lon1 + Math.atan2(
            Math.sin(bearingRad) * Math.sin(distanceMeters / R) * Math.cos(lat1),
            Math.cos(distanceMeters / R) - Math.sin(lat1) * Math.sin(lat2)
        );

        return {
            lat: lat2 * 180 / Math.PI,
            lng: lon2 * 180 / Math.PI
        };
    }

    const setViews = (inner) => {
        var a = document.getElementById("items");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            a.appendChild(inner[index])
        }
    }

    function generateArcPoints(center, radiusMeters, startAngleDeg, endAngleDeg, steps = 32) {
        const points = [];

        for (let i = 0; i <= steps; i++) {
            const bearing = startAngleDeg + ((endAngleDeg - startAngleDeg) * i) / steps;
            points.push(getDestinationPoint(center, radiusMeters, bearing));
        }

        return [center, ...points, center];
    }

    return (
        <div className="mapsfull-height">
            <div id="items" className="sidebar">
            </div>

            <div className="map-container">
                <LoadScript googleMapsApiKey="AIzaSyAe9bZGewj0M5fHhyhcUoR6iY0F41uIArk">
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={mapCenter}
                        zoom={14}
                        onLoad={onLoad}
                    >
                        {elements.map((el, index) => {
                            const arc = generateArcPoints(
                                el.start,
                                el.radius,
                                el.startAngle,
                                el.endAngle
                            );

                            return (
                                <React.Fragment key={index}>
                                    <Polyline
                                        path={[el.start, el.end]}
                                        options={{
                                            strokeColor: el.color,
                                            strokeOpacity: 1.0,
                                            strokeWeight: 3,

                                        }}
                                    />
                                    <Polygon
                                        paths={arc}
                                        options={{
                                            fillColor: el.color,
                                            fillOpacity: 0.2,
                                            strokeColor: el.color,
                                            strokeOpacity: 0.8,
                                            strokeWeight: 1
                                        }}
                                    />
                                </React.Fragment>
                            );
                        })}
                    </GoogleMap>
                </LoadScript>



            </div>
        </div>
    );
}


export default MapsInfo;